<template>
  <div class="fc-button">
    <span>{{this.text}}</span>
  </div>
</template>

<script>
export default {
  props: {
    text: String
  }
};
</script>

<style lang="scss" scoped>
.fc-button {
  cursor: pointer;
  position: relative;
  background: rgba($primary-color, 0.8);
  transition: all 1s cubic-bezier(0.165, 0.84, 0.44, 1);
  border: 3px solid #ff5100;
  box-shadow: 0px 0px 15px 0px $accent-color;
  min-width: 263px;
  box-sizing: border-box;
  padding: 20px 25px;
  height: 57px;
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    white-space: nowrap;
    transition: color 1s cubic-bezier(0.165, 0.84, 0.44, 1);
    font-size: 20px;
    color: #ff5100;
    letter-spacing: 0;
    text-align: center;
    text-transform: uppercase;
  }
  &:hover {
    background: rgba($primary-color, 1);
    //border: 3px solid $secondary-color;
    span {
      //color: $secondary-color;
    }
  }
}
</style>